import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../services/app-config.service';
import { CPPourNotaire } from '../models/cp-pour-notaire.model';
import { CerfaPJ } from '../models/form/cerfa-pj.model';
import { FormCerfaBean } from '../models/form/form-cerfa-bean.model';
import { RestService } from './rest.service';

/**
 * Récupération des éléments liés aux certificats de positionnement
 */
@Injectable()
export class CertificatPositionnementService extends RestService {

    /**
     * Construction
     */
    constructor(
      private readonly http: HttpClient
    ) {
      super();
    }

    /**
     * Récupérer les CP d'un notaire
     *
     * @param login nom du login
     * @returns {Observable<Array<string>>}
     */
     listePourNotaire(login: string): Observable<Array<CPPourNotaire>> {
        const url = `${AppConfigService.settings.urlServeur}rest/cp/listePourNotaire/?login=${login}`;
        return this.http.get<Array<CPPourNotaire>>(url);
    }

    /**
     * Lecture d'un CP donné
     *
     * @param number numéro du CP (année exercice '-' numéro dans l'année)
     */
    lecture(number: string): Observable<FormCerfaBean> {
        const url = `${AppConfigService.settings.urlServeur}rest/cp/lecture/?number=${number}`;
        return this.http.get<FormCerfaBean>(url);
    }

    /**
     * Ajout des pièces jointes d'un CP donné au CERFA en cours d'édition, et renvoie les fichiers créés
     *
     * @param number numéro du CP (année exercice '-' numéro dans l'année)
     */
    addPJ(number: string, idCerfa: number): Observable<Array<CerfaPJ>> {
        const url = `${AppConfigService.settings.urlServeur}rest/cp/addPJ/?number=${number}&idCerfa=${idCerfa}`;
        return this.http.get<Array<CerfaPJ>>(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/certificat-positionnement.service.ts